import { useTranslation } from 'next-i18next';
import Button from '@components/ui/Button';
import ProductAddToCartButton from '@components/product/ProductAddToCartButton';

import styles from './DeliveryMethodModal.module.scss';

interface DeliveryMethodModalContentProps {
  onCloseModal?: () => void;
}

export const DeliveryMethodModalContent = ({
  onCloseModal,
}: DeliveryMethodModalContentProps) => {
  const { t } = useTranslation('common');

  return (
    <>
      <div className={styles.mainText}>
        <div
          dangerouslySetInnerHTML={{
            __html: t('delivery.method.modal'),
          }}
        />
      </div>

      <ProductAddToCartButton changeDeliveryMethodToAddress />

      <Button
        type="button"
        variant="secondary"
        label={t('delivery.method.modal.cancel')}
        size="large"
        className={styles.button}
        handleClick={onCloseModal}
      />
    </>
  );
};

export default DeliveryMethodModalContent;
